import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import {
  EstadoDTO,
  EstadoResponseDTO,
} from '../../models/configuracoes/estado.model';

@Injectable({
  providedIn: 'root',
})
export class EstadoService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<EstadoResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<EstadoResponseDTO>(patch);
  }

  getById<T>(url: string): Observable<EstadoDTO> {
    return this.apiService.read<EstadoDTO>(url);
  }

  post<T>(url: string, data: EstadoDTO): Observable<EstadoDTO> {
    return this.apiService.create<EstadoDTO>(url, data);
  }

  put<T>(url: string, data: EstadoDTO): Observable<EstadoDTO> {
    return this.apiService.update<EstadoDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  buscarEstado(filtros: any, paginacao?: any): Observable<EstadoResponseDTO> {
  const params: any = { ...filtros, ...paginacao };
  return this.get<EstadoResponseDTO>('estado/buscar', params);
}



}
